import { render, staticRenderFns } from "./OfferInvitationsArchivedTab.vue?vue&type=template&id=1d3feb1e&"
import script from "./OfferInvitationsArchivedTab.vue?vue&type=script&lang=js&"
export * from "./OfferInvitationsArchivedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports